import { TemplateJobsGeneral } from './templateJobsGeneral';
import { JobState } from './jobState.model';
import { softwareUpgradeJob } from './softwareUpgradeJob';
import { TemplateJobs } from './templateJobs';
import { UserLog } from './UserLog.model';
import { UserDetailedLog } from './UserDetailedLog.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs';
import { logs } from '../../assets/conf_urls.json';
import { UserTemplateLog } from './UserTemplateLog.model';
import { ConflictLog } from './conflictLogs.model';
import { AuditLog } from './auditLogs.model';
import { WallpaperLog } from './wallpaperLogs.model';
import { UserDetailedLogWallpaper } from './UserDetailedLogWallpaper.model';

@Injectable()
export class LoggingService {

  constructor(private http: HttpClient) {
  }

  getLogs(searchText: string): Observable<{ data: UserTemplateLog[] }> {
    return this.http.post<{ data: UserTemplateLog[] }>(logs.getLogs, {
      "event": searchText
    });
  }

  getSWLogs(searchText: string): Observable<{ data: UserLog[] }> {
    return this.http.post<{ data: UserLog[] }>(logs.getLogs, {
      "event": searchText
    });
  }

  getDetailedLogs(jobId: string, ipAddress: string): Observable<{ data: UserDetailedLog[] }> {
    return this.http.post<{ data: UserDetailedLog[] }>(logs.getLogs, {
      "event": "logs_by_ip_and_job",
      "job_id": jobId,
      "ip_address": ipAddress
    });
  }

  getWallpaperDetailedLogs(jobId: string, ipAddress: string): Observable<{ data: UserDetailedLogWallpaper[] }> {
    return this.http.post<{ data: UserDetailedLogWallpaper[] }>(logs.getLogs, {
      "event": "wallpaper_logs_details",
      "job_id": jobId,
      "ip_address": ipAddress
    });
  }

  // getDetailedLogs2(jobId: string, ipAddress: string): Observable<{ data: any[] }> {
  //   let url = `https://rtcapps:444/api/jobs/${jobId}`
  //   return this.http.get<{ data: any[] }>(url);
  // }

  getUpcomingTemplatesJobs(tempId: string): Observable<{ data: TemplateJobs[] }> {
    return this.http.post<{ data: TemplateJobs[] }>(logs.getLogs, {
      "event": "upcoming_templates_jobs",
      "template_id": tempId
    });
  }

  getUpcomingTemplatesJobsData(): Observable<{ data: TemplateJobsGeneral[] }> {
    return this.http.post<{ data: TemplateJobsGeneral[] }>(logs.getLogs, {
      "event": "upcoming_templates_data"
    });
  }

  getUpComingSoftwareUpgrades(): Observable<{ data: softwareUpgradeJob[] }> {
    return this.http.post<{ data: softwareUpgradeJob[] }>(logs.getLogs, {
      "event": "upcoming_software_upgrades"
    });
  }

  removeUpComingSoftwareUpgrade(jobId): Observable<any> {
    return this.http.post<any>(logs.getLogs, {
      "event": "remove_sw_upgrade_logs",
      "job_id": jobId
    });
  }

  getConflictLogs(): Observable<{ data: ConflictLog[] }> {
    return this.http.post<{ data: ConflictLog[] }>(logs.getLogs, {
      "event": "conflict_logs"
    });
  }

  getAuditLogs(): Observable<{ data: AuditLog[] }> {
    return this.http.post<{ data: AuditLog[] }>(logs.getLogs, {
      "event": "audit_logs"
    });
  }

  getWallpaperLogs(): Observable<{ data: WallpaperLog[] }> {
    return this.http.post<{ data: WallpaperLog[] }>(logs.getLogs, {
      "event": "wallpaper_logs"
    });

  }

  getWallpaperStateLogs(id): Observable<{ data: JobState[] }> {
    let url = `https://rtcapps:444/api/jobs/${id}`
    return this.http.get<{ data: JobState[] }>(url);
  }

}
